// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0f0fdfc4","160":"d0f6a636","208":"455b061f","293":"a7c29a3a","516":"58bc44d4","519":"b5cfdd51","885":"ba8de936","917":"423b6788","946":"a948403e"}[chunkId] + ".chunk.js";
};